module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header_box_5"
  }, [_c('tab', {
    attrs: {
      "activeColor": '#118eea',
      "lineWidth": 2,
      "defaultColor": '#353535'
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.qiehuan('dzfp')
      }
    }
  }, [_c('span', {
    staticClass: "sp-title",
    staticStyle: {
      "display": "block",
      "height": "20px",
      "border-right": "1px #ddd solid"
    }
  }, [_vm._v("电子发票")])]), _vm._v(" "), _c('tab-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.qiehuan('zzfp')
      }
    }
  }, [_c('span', {
    staticClass: "sp-title",
    staticStyle: {
      "display": "block",
      "height": "20px",
      "border-right": "0"
    }
  }, [_vm._v("纸质发票")])])], 1), _vm._v(" "), (_vm.cw_type === 'dzfp') ? _c('div', {
    staticClass: "dzfp_tow",
    style: ({
      height: (_vm.pullHeight - 97) + 'px'
    })
  }, [_vm._l((_vm.dzfpList), function(item, index) {
    return _c('div', {
      staticClass: "touch"
    }, [_c('div', {
      staticClass: "item",
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "id": _vm.getById('dzfp', index)
      },
      on: {
        "touchstart": function($event) {
          $event.stopPropagation();
          return _vm.touchStart($event)
        },
        "touchend": function($event) {
          $event.stopPropagation();
          return _vm.touchEnd(index, 'dzfp', item.id, $event)
        },
        "touchmove": function($event) {
          $event.stopPropagation();
          return _vm.touchMove($event)
        }
      }
    }, [_c('div', {
      staticClass: "vux-form-preview weui-form-preview weui-fpbj ",
      attrs: {
        "data-v-474fe04d": ""
      }
    }, [_c('div', {
      staticClass: "weui-form-preview__hd"
    }, [_c('label', {
      staticClass: "weui-form-preview__label",
      staticStyle: {
        "width": "70%",
        "text-align-last": "left"
      }
    }, [_vm._v("\n                            " + _vm._s(item.invoiceBuyerName) + "\n                        ")]), _vm._v(" "), _c('em', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v("¥" + _vm._s(_vm._f("currencyFilter")(item.invoiceTotalAmount, 2)))])]), _vm._v(" "), _c('div', {
      staticClass: "weui-form-preview__bd"
    }, [_c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label"
    }, [(item.invoiceKind === '01' || item.invoiceKind === '02' || item.invoiceKind === '03') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-01"
    }, [_vm._v("纸专")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '04') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-04"
    }, [_vm._v("纸普")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '10') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("电普")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '9') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("区块链")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '08') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("电专")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '81') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("全电")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '82') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("全电")]) : _vm._e(), _vm._v("\n                                " + _vm._s(item.invoiceSellerName) + "\n                            ")]), _vm._v(" "), _c('span', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v(_vm._s(_vm._f("dateFilter")(item.invoiceDate, 'yyyy-MM-dd')))])])])]), _vm._v(" "), _c('a', {
      staticClass: "remove",
      staticStyle: {
        "height": "100%",
        "line-height": "80px"
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(this, item, index)
        }
      }
    }, [_vm._v("删除")])])])
  }), _vm._v(" "), (_vm.nodzfp) ? _c('div', {
    staticClass: "noInvoice-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/noInvoice.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("您还没有添加过发票哦~")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.cw_type === 'zzfp') ? _c('div', {
    staticClass: "dzfp_one",
    style: ({
      height: (_vm.pullHeight - 97) + 'px'
    })
  }, [_vm._l((_vm.zzfpList), function(item, index) {
    return _c('div', {
      staticClass: "touch"
    }, [_c('div', {
      staticClass: "item",
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "id": _vm.getById('zzfp', index)
      },
      on: {
        "touchstart": function($event) {
          $event.stopPropagation();
          return _vm.touchStart($event)
        },
        "touchend": function($event) {
          $event.stopPropagation();
          return _vm.touchEnd(index, 'zzfp', item.id, $event)
        },
        "touchmove": function($event) {
          $event.stopPropagation();
          return _vm.touchMove($event)
        }
      }
    }, [_c('div', {
      staticClass: "vux-form-preview weui-form-preview weui-fpbj ",
      staticStyle: {
        "background-image": "none"
      },
      attrs: {
        "data-v-474fe04d": ""
      }
    }, [_c('div', {
      staticClass: "weui-form-preview__hd"
    }, [_c('label', {
      staticClass: "weui-form-preview__label",
      staticStyle: {
        "width": "70%",
        "text-align-last": "left"
      }
    }, [_vm._v(_vm._s(item.invoiceBuyerName))]), _vm._v(" "), _c('em', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v("¥" + _vm._s(_vm._f("currencyFilter")(item.invoiceTotalAmount, 2)))])]), _vm._v(" "), _c('div', {
      staticClass: "weui-form-preview__bd"
    }, [_c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label"
    }, [(item.invoiceKind === '01' || item.invoiceKind === '02' || item.invoiceKind === '03') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-01"
    }, [_vm._v("纸专")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '04') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-04"
    }, [_vm._v("纸普")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '10') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("电普")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '9') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("区块链")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '08') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("电专")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '81') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("全电")]) : _vm._e(), _vm._v(" "), (item.invoiceKind === '82') ? _c('span', {
      staticClass: "invoice-kind-icon invoice-kind-10"
    }, [_vm._v("全电")]) : _vm._e(), _vm._v("\n                                " + _vm._s(item.invoiceSellerName) + "\n                            ")]), _vm._v(" "), _c('span', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v(_vm._s(_vm._f("dateFilter")(item.invoiceDate, 'yyyy-MM-dd')))])])])]), _vm._v(" "), _c('a', {
      staticClass: "remove",
      staticStyle: {
        "height": "100%",
        "line-height": "80px"
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteItem(this, item, index)
        }
      }
    }, [_vm._v("删除")])])])
  }), _vm._v(" "), (_vm.nozzfp) ? _c('div', {
    staticClass: "noInvoice-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/noInvoice.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("您还没有添加过发票哦~")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('confirm', {
    staticClass: "zzz newConfirm",
    attrs: {
      "on-hide": "onHide"
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm,
      "on-show": _vm.onShow
    },
    model: {
      value: (_vm.confirmStatus),
      callback: function($$v) {
        _vm.confirmStatus = $$v
      },
      expression: "confirmStatus"
    }
  }, [_c('cell-form-preview', {
    attrs: {
      "list": _vm.confirmList
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "1px #e6e6e6 solid",
      "height": "1px",
      "margin": "0 10px 20px",
      "overflow": "hidden"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px",
      "color": "#333",
      "font-size": "16px",
      "font-weight": "bold",
      "height": "1.3em"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "margin-right": "10px",
      "vertical-align": "middle",
      "margin-top": "-1px"
    },
    attrs: {
      "src": require("../../assets/img/tit.png")
    }
  }), _vm._v("确认要丢弃该发票吗？")])], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df417a06"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fpj/myfp.vue
// module id = 353
// module chunks = 0